import React, { useState, useEffect, useRef, prevState } from "react";
import { formatter, decompressToBase64 } from '../../utils/common.js';
import { format, isSameHour, setDayOfYear } from 'date-fns';
import Modal from 'react-modal';
import { AddReordersToCart, AddToCart, GetCount } from '../ShoppingCart/CartHandler.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faStar } from '@fortawesome/free-regular-svg-icons';
import { faGift, faCog } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import ReactFlexyTable from "react-flexy-table";
import "react-flexy-table/dist/index.css";
import PayLogo from "../CSS/CommonCSS/pay-svgrepo-com.svg"
import SaveLogo from "../CSS/CommonCSS/Save.png"
import { Link, useNavigate } from "react-router-dom";
import "../Portal/AccountInfo.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import "./Dashboard.css"
import Drawer from '@mui/material/Drawer';
import "./invoice.css";
import "./portal.css";
import FullWidthTabs from "./PortalTabs.js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { FormatAlignJustifyTwoTone } from "@mui/icons-material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import "./ItemDetails.css"
import { Box, Button, Grid, Menu, MenuItem, TextField } from "@mui/material";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { FaBars, FaTimes, FaHome, FaUser, FaCog } from "react-icons/fa";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import paidLogo from '../../assets/ecommer-paid-logo1.png'


const itemDetailsColumns = [

  {
    id: 1,
    label: 'Order Number',
    minWidth: 150,
    align: 'left',
  },
  {
    id: 2,
    label: 'Request Ship Date',
    minWidth: 150,
    align: 'center',
  },
  {
    id: 3,
    label: 'Item Number',
    minWidth: 120,
    align: 'center',
  },
  {
    id: 4,
    label: 'Item Description',
    minWidth: 300,
    align: 'center',
  },
  {
    id: 5,
    label: 'Site ID',
    minWidth: 70,
    align: 'center',
  },
  {
    id: 6,
    label: 'Price',
    minWidth: 70,
    align: 'center',
  },
  {
    id: 7,
    label: 'Quantity',
    minWidth: 100,
    align: 'right',
  },
  {
    id: 6,
    label: 'Extended Price',
    minWidth: 150,
    align: 'right',
  },
];

const PaymentDataColumns = [

  {
    id: 1,
    label: 'Order Number',
    minWidth: 150,
    align: 'left',
  },
  {
    id: 4,
    label: 'Payment Type',
    minWidth: 300,
    align: 'center',
  },
  {
    id: 5,
    label: 'Remaining Amount',
    minWidth: 70,
    align: 'center',
  },
  {
    id: 6,
    label: 'Customer Name',
    minWidth: 70,
    align: 'center',
  },
  {
    id: 2,
    label: 'Order Date',
    minWidth: 150,
    align: 'center',
  },
  {
    id: 3,
    label: 'Due Date',
    minWidth: 120,
    align: 'center',
  }
];

const orderColumns = [
  { label: 'Transaction #', minWidth: 120 },
  { label: 'Type', minWidth: 20 },
  { label: 'Source', minWidth: 20 },
  {
    label: 'Date',
    minWidth: 80,
    align: 'center',

  },
  {
    label: 'PO#',
    minWidth: 100,
    align: 'left',
  },
  {
    label: 'Total',
    minWidth: 90,
    align: 'center',
  },
  {
    label: 'Status',
    minWidth: 100,
    align: 'left',
  },
  {
    label: 'Order Now',
    minWidth: 120,
    align: 'left',
  },
];
const invoiceColumn = [
  { label: 'Transaction #', minWidth: 120 },
  { label: 'Type', minWidth: 20 },
  { label: 'Source', minWidth: 20 },
  {
    label: 'Date',
    minWidth: 80,
    align: 'center',

  },
  {
    label: 'PO#',
    minWidth: 100,
    align: 'left',
  },
  {
    label: 'Total',
    minWidth: 90,
    align: 'left',
  },
  {
    label: 'Status',
    minWidth: 100,
    align: 'left',
  },
  {
    label: 'Order Now',
    minWidth: 100,
    align: 'left',
  },
  {
    label: 'Actions',
    minWidth: 100,
    align: 'left',
  },
];
const all = [
  { label: 'Transaction #', minWidth: 120 },
  { label: 'Type', minWidth: 20 },
  { label: 'Source', minWidth: 20 },
  {
    label: 'Date',
    minWidth: 60,
    align: 'center',

  },
  {
    label: 'PO#',
    minWidth: 100,
    align: 'left',
  },
  {
    label: 'Total',
    minWidth: 90,
    align: 'left',
  },
  {
    label: 'Status',
    minWidth: 90,
    align: 'left',
  },
  {
    label: 'Order Now',
    minWidth: 90,
    align: 'left',
  },
];


Modal.setAppElement('#root');

const apiUrl = process.env.REACT_APP_BASEURL;

function Portal({ token, setToken, cartCount, setCartCount, }) {



  const [activeItem, setActiveItem] = useState(null);
  const backorderedStyle = () => ({
    fontWeight: "bold",
    color: "red"
  });
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };
  const [balance, setBalance] = useState(0);
  const [currentInvoiceData, setCurrentInvoiceData] = useState([]);
  const [currentOrderData, setCurrentOrderData] = useState([]);
  const [currentQuoteData, setCurrentQuoteData] = useState([]);
  const [impData, setImpData] = useState(null);
  const [image, setImage] = useState();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [orderData, setOrderData] = useState([]);
  const [dashOrder, setDashOrder] = useState(false);
  const [dashInvoice, setDashInvoice] = useState(true);
  const [include, setInclude] = useState("invoice");
  const [lastInvDate, setLastInvDate] = useState("");
  const [lastItemAmount, setLastItemAmount] = useState(0);
  const [lastInvData, setLastInvData] = useState([]);
  const [lastItemData, setLastItemData] = useState([]);
  const [customerData, setCustomerData] = useState();
  const [pymData, setPymData] = useState([]);
  const [hstPymData, setHstPymData] = useState([]);
  const [openPymData, setOpenPymData] = useState([]);
  const [trackingData, setTrackingData] = useState([]);
  const [mergedInvData, setMergedInvData] = useState([]);
  const [mergedOrderData, setMergedOrderData] = useState([]);
  const [logo, setLogo] = useState("");
  // const { row } = props;


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
  );


  const downloadExcelProps = {
    type: 'filtered',
    title: 'test',
    showLabel: true
  }

  const GetAllOrders = () => {

    axios.get(apiUrl + "/api/Orders/GetAllOrders", {
      headers: headers
    })
      .then((response) => {
        setCurrentOrderData(response.data); // Make sure response.data is an array
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function handleImage(e) {
    console.log(e.target.files)
    setImage(e.target.files[0])
  }

  function submitImage() {
    const formData = new FormData()
    formData.append('image', image)
    axios.post("url", formData)
      .then((res) => {
        // console.log(res)
      })
  }
  const GetBalance = () => {

    axios.get(apiUrl + "/api/Orders/GetBalance", {
      headers: headers
    })
      .then((response) => {
        setBalance(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };


  const GetPaymentData = () => {

    axios.get(apiUrl + "/api/Orders/GetPaymentData", {
      headers: headers
    })
      .then((response) => {
        setPymData(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };



  const GetOpenPaymentData = () => {

    axios.get(apiUrl + "/api/Orders/GetOpenPaymentData", {
      headers: headers
    })
      .then((response) => {
        setOpenPymData(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetHistoryPaymentData = () => {

    axios.get(apiUrl + "/api/Orders/GetHistoryPaymentData", {
      headers: headers
    })
      .then((response) => {
        setHstPymData(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };


  const GetTrackingNumber = () => {

    axios.get(apiUrl + "/api/Orders/GetTrackingNum", {
      headers: headers
    })
      .then((response) => {
        setTrackingData(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };



  const GetCustomerInfo = () => {
    axios.get(`${apiUrl}/api/Users/GetCustomerById?customerNumber=${token.customerNumber}`, {
      headers: headers
    })
      .then((response) => {
        setCustomerData(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };

  // console.log(`Customer Data: ${JSON.stringify(customerData)}`);


  const GetLastInvoice = () => {

    axios.get(`${apiUrl}/api/Orders/GetLastInvoice?include=${include}`, {
      headers: headers
    })
      .then((response) => {
        setLastInvDate(response.data.invodate)
        setLastInvData(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };

  // console.log(` Invoice Date: ${lastInvDate}`);

  const GetLastInvoiceItem = () => {

    axios.get(`${apiUrl}/api/Orders/GetLastInvoiceItems?include=${include}`, {
      headers: headers
    })
      .then((response) => {
        setLastItemAmount(response.data[0].price)
        setLastItemData(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };
  // console.log(` Invoice Item: ${lastItemData}`);
  // console.log(` Invoice Price: ${lastItemAmount}`);


  const getCurrentInvoices = () => {

    axios.get(`${apiUrl}/api/Orders/GetAllInvoice`, {
      headers: headers
    })
      .then((response) => {
        setCurrentInvoiceData(response.data); // Make sure response.data is an array
      })
      .catch((error) => {
        console.log(error);
      });
  }



  const getHistoricInvoices = () => {

    axios.get(apiUrl + "/api/HistoricInvoice/GetAllHistoricInvoices", {
      headers: headers
    })
      .then((response) => {
        setHistoricInvoiceData(response.data); // Make sure response.data is an array
      })
      .catch((error) => {
        console.log(error);
        setHistoricInvoiceData();
      });
  }



  function GetAllInvoices() {
    let allInvoices = [];

    if (mergedInvData || mergedInvData.length !== 0) {
      for (let i = 0; i < mergedInvData.length; i++) {
        allInvoices.push(mergedInvData[i])
      }
    };

    // console.log("All Invoices after Adding Current Invoice Data: ", allInvoices);

    if (historicInvoiceData || historicInvoiceData.length !== 0) {
      for (let i = 0; i < historicInvoiceData.length; i++) {
        allInvoices.push(historicInvoiceData[i])
      }
    };

    // console.log("All Invoices after Adding Historic Invoice Data: ", allInvoices);

    setAllInvoiceData(allInvoices);
  };


  const GetLastFiveInvoice = () => {
    if (!allInvoiceData || allInvoiceData.length === 0) {
      console.error("No Invoices Found");
    } else {
      const sortedInvoices = allInvoiceData.sort((a, b) => {
        const dateA = a.invodate;
        const dateB = b.invodate;

        // Handle invalid dates
        // if (isNaN(dateA) || isNaN(dateB)) {
        //     console.error("Invalid date found in invoices:", a.invodate, b.invodate);
        //     return 0; // Could also return 1 or -1 depending on how you want to handle it
        // }

        return dateB - dateA; // Sort in descending order (most recent first)
      });

      const lastFiveInvoices = sortedInvoices.slice(0, 5);
      setLastInvoice(lastFiveInvoices);
    }
  };

  const GetLastOrder = () => {
    if (!mergedOrderData || mergedOrderData.length === 0) {
      console.error("No Orders Found");
    } else {
      const sortedOrders = mergedOrderData.sort((a, b) => {
        const dateA = format(Date.parse(a.ordrdate), "MM/dd/yyyy");
        const dateB = format(Date.parse(b.ordrdate), "MM/dd/yyyy");

        // Handle invalid dates
        // if (isNaN(dateA) || isNaN(dateB)) {
        //     console.error("Invalid date found in orders:", a.ordrdate, b.ordrdate);
        //     return 0; // Could also return 1 or -1 depending on how you want to handle it
        // }

        return dateB - dateA; // Sort in descending order (most recent first)
      });

      const lastFiveOrders = sortedOrders.slice(0, 5);
      setLastOrder(lastFiveOrders);
    }
  };

  //Call the functions to populate fiveLastInvoices and fiveLastOrder


  const GetInvoiceItems = (sopnumbe) => {

    // console.log("GetInvoiceItems line 311 sopnumbe:", sopnumbe);
    axios.get(apiUrl + `/api/Orders/GetInvoiceItems?include=${lastOrderInclude}&SOPNumbe=${sopnumbe}`, {
      headers: headers
    })
      .then((response) => {
        // console.log("Invoice Items: ", response.data);
        if (!response.data) {
          alert("Unfortunately, some of the items on this invoice cant be re-ordered online. Call us and we will assist you.");
        } else {
          setInvoiceItems(response.data); // Make sure response.data is an array
        }
      })
      .catch((error) => {
        alert("Unfortunately, some of the items on this invoice cant be re-ordered online. Call us and we will assist you.");
        console.log(error);
      });
  };

  const GetPastDue = () => {
    axios.get(apiUrl + `/api/Orders/GetPastDue`, {
      headers: headers
    })
      .then((response) => {
        // console.log("Past Due : ", response.data);
        setPastDue(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetPurchasedItems = () => {

    axios.get(apiUrl + `/api/Orders/GetPurchasedItems?include=${purchasedInclude}`, {
      headers: headers
    })
      .then((response) => {
        setPurchasedItems(response.data); // Make sure response.data is an array

      })
      .catch((error) => {
        console.log(error);
      });
  };


  const GetAllQuotes = () => {
    axios.get(apiUrl + "/api/Orders/GetAllQuotes", {
      headers: headers
    })
      .then((response) => {
        const data = response.data;

        setCurrentQuoteData(data); // Make sure response.data is an array
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const GetSopDocument = (soptype, sopnumbe) => {
    // console.log("Here we are in GetSopDocument Line 235:", soptype, sopnumbe);
    axios.get(apiUrl + `/api/Orders/GetSopDocument?sopType=${soptype}&sopNumbe=${sopnumbe}`, {
      headers: headers
    })
      .then((response) => {
        // console.log("SopDocument line 235: ", response.data);
        sopDocument = response.data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getReport = (docnum, name, type) => {

    let docNum = docnum.trim();
    console.log(`name: ${name}, docNumber: ${docNum}, Type: ${type}`)
    axios.get(apiUrl + `/api/Orders/einvoicereport?reportName=${name}&invoice=${docNum}&SOPTypeString=${type}`, {
      headers: headers
    })
      .then((response) => {
        reportOpen(response.data);
        console.log(`data: ${JSON.stringify(response.data, 2, null)}`)
      })
      .catch((error) => {
        console.log(error);
      });


  }

  useEffect(() => {

    const ordData = currentOrderData
      .map(ord => {
        const matchedOrders = trackingData.find(tra => tra.sopnumbe === ord.sopnumbe);

        if (matchedOrders) {
          return {
            ...ord,
            trackingNumber: matchedOrders.trackingNumber
          };
        }
        return null; // If no match, return null (we'll filter these out)
      })
      .filter(orde => orde !== null);
    setMergedOrderData(ordData);
  }, [currentOrderData, trackingData])




  useEffect(() => {
    const invData = currentInvoiceData
      .map(inv => {
        const matchedPymData = pymData.filter(pym => pym.sopnumbe === inv.sopnumbe);
        const matchedTrackData = trackingData.find(track => track.sopnumbe === inv.sopnumbe);


        return {
          ...inv,
          pymttype: matchedPymData ? matchedPymData.pymttype : null,
          trackingNumber: matchedTrackData ? matchedTrackData.trackingNumber : null,

        }
      })
      .filter(invo => invo.pymttype !== null || invo.trackingNumber !== null);
    setMergedInvData(invData)

  }, [currentInvoiceData, pymData, trackingData])


  // console.log(` sorted Data: ${JSON.stringify(mergedInvData, null, 2)}`);

  // Logic to update mainArr


  const [historicInvoiceData, setHistoricInvoiceData] = useState([]);

  function reportOpen(report) {
    const reportObject = JSON.parse(report.value);

    if (!reportObject.reportBytes || reportObject.reportBytes.length === 0) {
      alert("Failed to open PDF: Report data is missing or invalid.");
      return;
    }

    // Decode base64 to a byte array
    const byteArray = base64ToArrayBuffer(reportObject.reportBytes);

    // Create a blob from the byte array
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Create a URL for the blob
    const url = URL.createObjectURL(blob);

    // Check if Internet Explorer
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      // For Internet Explorer
      window.navigator.msSaveOrOpenBlob(blob, "DownloadedOrder.pdf");
    } else {
      // For other browsers
      window.open(url, '_blank');
    }
  }

  function base64ToArrayBuffer(base64) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const arr = new Uint8Array(len);

    for (let i = 0; i < len; i++) {
      arr[i] = binaryString.charCodeAt(i);
    }

    return arr.buffer;
  }


  const handleClick = (order) => {
    // console.log(JSON.stringify(order));
    setSelectedOrder(order)
    setIsOpen(true);
  }

  const headers = ({
    "Accept": "application/json",
    "Content-Type": "application/json",
    'Authorization': 'Bearer ' + token.token
  });


  const [selectionHeader, setSeletionHeader] = useState("Dashboard")
  const [selectionDescription, setSelectionDescription] = useState("")
  const [allInvoiceData, setAllInvoiceData] = useState([]);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const [lastInvoice, setLastInvoice] = useState([]);
  const [lastOrder, setLastOrder] = useState([]);
  const [lastInvoiceItems, setLastInvoiceItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [invoiceSearch, setInvoiceSearch] = useState('');
  const [quoteSearch, setQuoteSearch] = useState('');


  const [lastOrderInclude, setLastOrderInclude] = useState("invoice");

  const lastOrderIncludeChangeHandler = (e) => {
    setLastOrderInclude(e.target.value)
  }

  const mounted = useRef();
  const onRequestClose = () => {
    setIsOpen(false);
  }

  const navigate = useNavigate();

  const onRequestModalClose = () => {
    setIsModalOpen(false);

  }

  const [options, setOptions] = useState({
    // labels: {
    confirmable: "OK",
    cancellable: ""
    // }
  });
  const [orderList, setOrderList] = useState([]);

  const [pastDue, setPastDue] = useState(0);

  const pickingStyle = () => ({
    fontWeight: "bold"
  });

  const [purchasedItems, setPurchasedItems] = useState([]);
  const [purchasedInclude, setPurchasedInclude] = useState("invoice");
  const purchasedIncludeChangeHandler = (e) => {
    setPurchasedInclude(e.target.value);
  }

  const reorderItemClick = (item) => {
    setActiveItem(item);
    setIsModalOpen(true);
    //AddToCart(item.itemnmbr, item.unitprce, 1);
    //setCart(GetCart);
  }




  let sopDocument;

  const reOrderItems = (docnum) => {

    if (viewInvoices) {
      for (let i = 0; i < currentInvoiceData.length; i++) {
        if (currentInvoiceData[i].sopnumbe === docnum) {
          sopDocument = currentInvoiceData[i];
        }
      }
      // console.log("sopDocument in ReOrder Items invoice", sopDocument);
    } else if (viewOrders) {
      for (let i = 0; i < currentOrderData.length; i++) {
        if (currentOrderData[i].sopnumbe === docnum) {
          sopDocument = currentOrderData[i];
          break;
        }
      };
    } else if (viewQuotes) {
      for (let i = 0; i < currentQuoteData.length; i++) {
        if (currentQuoteData[i].sopnumbe === docnum) {
          sopDocument = currentQuoteData[i];
          break;
        }
      };
    } else if (lastOrderInclude === "order") {
      for (let i = 0; i < currentOrderData.length; i++) {
        if (currentOrderData[i].sopnumbe === docnum) {
          sopDocument = currentOrderData[i];
          break;
        }
      };

    } else if (lastOrderInclude === "invoice") {
      for (let i = 0; i < currentInvoiceData.length; i++) {
        if (currentInvoiceData[i].sopnumbe === docnum) {
          sopDocument = currentInvoiceData[i];
        }
      }
    } else if (lastOrderInclude === "all") {

      for (let i = 0; i < currentInvoiceData.length; i++) {
        if (currentInvoiceData[i].sopnumbe === docnum) {
          sopDocument = currentInvoiceData[i];
        }
      }
      for (let i = 0; i < currentOrderData.length; i++) {
        if (currentOrderData[i].sopnumbe === docnum) {
          sopDocument = currentOrderData[i];
          break;
        }
      };

    }

    // console.log("Here you are in reOrderItems before setTimeout",sopDocument)
    setTimeout(SopDocumentReturn, 250);
  }

  const SopDocumentReturn = () => {
    // console.log("Here in SopDocumentReturn SopDocument",sopDocument)
    if (sopDocument) {
      sopDocument.details.map((detail) => {
        // console.log(`Mustafa this alert: ${detail.itemnmbr} and ${detail.unitprce} and ${detail.quantity}`)
        AddReordersToCart(detail.itemnmbr, detail.unitprce, detail.quantity);
        setCartCount(GetCount());
      }

      );
    } else {
      // console.log("details array is empty!");
    }
  }

  const reorderOrderClick = () => {

    if (lastOrderInclude === "invoice" && lastInvoice.sopnumbe) {
      GetInvoiceItems(lastInvoice.sopnumbe);
    } else if (lastOrderInclude === "invoice" && lastInvoice === null) {
      alert("The information you selected was not found. Please try again");
    } else {
      if (lastOrder === null) {
        alert("There was no order set on your reorder click. Please try again");
      } else {
        // console.log("reorderOrderClick order line 383", lastOrder);
        lastOrder.details.forEach((detail) => {
          // console.log("reorderOrderClick order line 385",detail.itemnmbr, detail.unitprce, detail.quantity);
          AddToCart(detail.itemnmbr, detail.unitprce, detail.quantity);
          setCartCount(GetCount());
        });
      }
    }
    //AddToCart(item.itemnmbr, item.unitprce, 1);
    //setCart(GetCart);
  }

  useEffect(() => {
    axios
      .get(apiUrl + `/api/Header/GetLogo`, {})
      .then((response) => {
        const thisLogo = response.data;
        setLogo(thisLogo.image);
      })
      .catch((error) => {
        console.log(error);
      });
  })


  const handleItemDetails = (docnum) => {
    let data = null;

    if (viewInvoices) {
      data = GetSopDocument(3, docnum); // Assuming this function returns the data directly
      // console.log("sopDocument in ReOrder Items invoice", data);
    } else if (viewOrders) {
      data = currentOrderData.find(order => order.sopnumbe === docnum);
    } else if (viewQuotes) {
      data = currentQuoteData.find(quote => quote.sopnumbe === docnum);
    }

    // console.log("Here you are in reOrderItems before setTimeout", data);

    if (data) {
      setImpData(data); // This will trigger a re-render of the component
    } else {
      setImpData(null); // Handle the case where no data is found
    }

    showItemDetails(); // Assuming this function is used to display the details component
  }


  const tableBackHandler = () => {
    if (currentOrderData || impData) {
      currentOrderData.forEach(order => {
        const orderNumber = order.sopnumbe;
        impData.details.forEach(data => {
          const secOrderNumber = data.sopnumbe;
          if (orderNumber === secOrderNumber) {
            showOrders();
          }
        })
      })
    }

    if (currentQuoteData || impData) {
      currentQuoteData.forEach(quote => {
        const quoteNumber = quote.sopnumbe;
        impData.details.forEach(data => {
          const secQuoteNumber = data.sopnumbe;
          if (quoteNumber === secQuoteNumber) {
            showQuotes();
          }
        })
      })
    }
  }

  const itemDetails = () => {
    // console.log("Here in itemDetails impData", impData);

    const hasData = impData && Array.isArray(impData.details) && impData.details.length > 0;

    return (
      <>
        <div onClick={tableBackHandler}><KeyboardBackspaceIcon sx={{ fontSize: 50, padding: 1, color: '#000', marginRight: 10 }} /></div>
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
          <TableContainer sx={{ maxHeight: 440 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow >
                  {itemDetailsColumns.map((column) => (
                    <TableCell

                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth, backgroundColor: '#afaf97' }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {hasData ? (
                  impData.details.map((detail, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <label className="d-trx"><span className="trx-s">{detail.sopnumbe}</span></label>
                      </TableCell>
                      <TableCell>
                        <label className="d-type"><span>{format(Date.parse(detail.reqShipDate), "MM/dd/yyyy")}</span></label>
                      </TableCell>
                      <TableCell>
                        <label className="trx-date"><span className="d-date-s">{detail.itemnmbr}</span></label>
                      </TableCell>
                      <TableCell>
                        <label className="trx-date"><span className="d-date-s">{detail.itemdesc}</span></label>
                      </TableCell>
                      <TableCell>
                        <label className="po"><span>{detail.locncode}</span></label>
                      </TableCell>
                      <TableCell>
                        <label className="trx-total ml-4"><span className="d-total-s">{formatter.format(detail.unitprce)}</span></label>
                      </TableCell>
                      <TableCell>
                        <label className="or-status"><span>{detail.quantity}</span></label>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={itemDetailsColumns.length} align="center">
                      No data found in the Item Details List!
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </>
    );
  };




  const [selectedOrder, setSelectedOrder] = useState({});





  const setStatusFont = (field) => {
    if (field === "Picking ") {
      return (<td style={pickingStyle()}>{field}</td>);
    }
    else if (field === "Backordered") {
      return (<td style={backorderedStyle()}>{field}</td>);
    }
    else if (field == "Shipped") {
      return (<td style={shippedStyle()}>{field}</td>);
    }
    else {
      return (<td>{field}</td>);
    }
  };

  const shippedStyle = () => ({
    fontWeight: "bold",
    color: "green"
  });

  const showDashboard = () => {
    setViewItemDetails(false);
    setAccInfo(false)
    setViewDashboard(true);
    setViewInvoices(false);
    setViewOrders(false);
    setViewQuotes(false);
    setSeletionHeader("Customer Dashboard");
    setSelectionDescription("Here is an overview of your account information.");
  };

  const showItemDetails = () => {
    setAccInfo(false)
    setViewDashboard(false);
    setViewInvoices(false);
    setViewOrders(false);
    setViewQuotes(false);
    setViewItemDetails(true);
    setSeletionHeader("Item Detail");
    setSelectionDescription("Your recent activities.");
  }

  const showInvoices = () => {
    setViewItemDetails(false);
    setAccInfo(false)
    setViewDashboard(false);
    setViewInvoices(true);
    setViewOrders(false);
    setViewQuotes(false);
    setSeletionHeader("Invoices");
    setSelectionDescription("A list of all invoices associated with this account.");
  };

  const showOrders = () => {
    setViewItemDetails(false);
    setAccInfo(false)
    setViewDashboard(false);
    setViewInvoices(false);
    setViewQuotes(false);
    setViewOrders(true);
    setSeletionHeader("Open Orders");
    setSelectionDescription("A list of completed orders purchased under this account");
  };


  const showQuotes = () => {
    setViewItemDetails(false);
    setViewDashboard(false);
    setViewInvoices(false);
    setViewOrders(false);
    setViewQuotes(true);
    setAccInfo(false)
    setSeletionHeader("Portal");
    setSelectionDescription("A list of quotes offered to this account");
  };

  const signOut = () => {
    sessionStorage.removeItem('token');
    setToken();
    // window.location.reload(true);

  }

  const showAccountInfo = () => {
    setViewItemDetails(false);
    setViewDashboard(false);
    setViewInvoices(false);
    setViewOrders(false);
    setViewQuotes(false);
    setAccInfo(true);
    setSeletionHeader("Account Information");
    setSelectionDescription("Here is an overview of your account information!");
  }

  const [sortDirection, setSortDirection] = useState(null);
  const [viewDashboard, setViewDashboard] = useState(true);
  const [viewInvoices, setViewInvoices] = useState(false);
  const [viewOrders, setViewOrders] = useState(false);
  const [viewQuotes, setViewQuotes] = useState(false);
  const [accInfo, setAccInfo] = useState(false);
  const [viewItemDetails, setViewItemDetails] = useState(false);


  useEffect(() => {
    if (!mounted.current) {
      getCurrentInvoices();
      getHistoricInvoices();
      GetBalance();
      showDashboard();
      // GetCart();
      // GetLastFiveInvoiceItems();
      GetPurchasedItems();
      GetPastDue();
      GetAllOrders();
      GetAllQuotes();

    }

  }, []);

  useEffect(() => {
    GetAllInvoices();
    GetLastFiveInvoice();
  }, [mergedInvData, historicInvoiceData])

  useEffect(() => {
    GetLastOrder();
  }, [mergedOrderData])

  useEffect(() => {
    GetLastFiveInvoice();
  }, [allInvoiceData])

  useEffect(() => {
    GetLastInvoice();
    GetLastInvoiceItem();
  }, [include])

  useEffect(() => {
    GetCustomerInfo();
  }, [token.customerNumber])

  useEffect(() => {
    GetPaymentData();
    GetTrackingNumber();
    GetHistoryPaymentData();
    GetOpenPaymentData();
  }, [])


  const dashboardOpen = () => {
    return (

      <div className=" bg-gray-50 min-h-screen">

        <div className="flex flex-col justify-center items-center my-2">
          <h1 className="text-2xl font-semibold text-gray-900">DASHBOARD</h1>
          <p className="text-sm text-gray-600">Welcome, <strong>{token.firstName}</strong> <strong>{token.lastName}</strong></p>
        </div>

        {/* Header Section */}
        <div className=" p-10 flex flex-wrap justify-between items-center overflow-auto">
          {/* Left Section: Profile Picture and Logo */}
          <div className="flex items-center space-x-6  sm:mb-0">
            <img className="w-20 h-20 rounded-full" src="https://i1.rgstatic.net/ii/profile.image/314621238415361-1452022956276_Q512/John-Mathiason.jpg" alt="Profile" />
            {customerData && (

              <div className="flex flex-col">
                <p className="text-sm md:my-0.5 font-semibold">{customerData.custname}</p>
                <p className="text-sm text-gray-900 md:my-0.5  flex flex-column">{customerData.address1} <span>{customerData.state}, {customerData.city}, {customerData.zip}</span></p>
                <p className="text-sm text-gray-900 md:my-0.5 ">Account Number: 100586</p>
                <p className="text-sm text-gray-900 md:my-0.5 ">Account Rep: <span className="">PAUL WILKERSON</span></p>
              </div>
            )}
          </div>

          {/* Right Section: Logo */}
          <div className="flex items-center justify-center sm:block hidden">
            <img className="w-32 h-16" src={"data:image/png;base64, " + logo} alt="Logo" />
          </div>
        </div>

        {/* Customer Info Section */}
        <div className=" px-12 pb-8 flex flex-wrap justify-between">
          <div className="w-full sm:w-auto mb-4 sm:mb-0">
            <div className="space-y-2">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Account Status</h3>
              <p className="text-sm text-blue-800">Balance: <span>{formatter.format(balance)}</span></p>
              <p className="text-sm text-red-800">Past Due: <span>{formatter.format(pastDue)}</span></p>
              <p className="text-sm text-gray-800">Point Balance: {"2333"}</p>
              <p className="text-sm text-gray-800">Account Rep: <span>10847</span></p>
              <p className="text-sm text-gray-800">Last Invoice: <span>{formatDate(lastInvDate)}</span></p>
              <p className="text-sm text-gray-800">Last Purchase: <span>{formatter.format(lastItemAmount)}</span></p>
            </div>
          </div>
          <div className="w-full sm:w-auto">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">Preferences</h3>
            <div className="space-y-2">
              <p className="text-sm text-gray-800">Shipping Method: <span className="text-gray-600">{customerData && customerData.shipmthd}</span></p>
              <p className="text-sm text-gray-800">Tax Schedule: <span className="text-gray-600">{customerData && customerData.taxschid}</span></p>
              <p className="text-sm text-gray-800">Tax Exempt Number: <span className="text-gray-600">{customerData && customerData.taxexmt2}</span></p>
              <p className="text-sm text-gray-800">Payment Method: <span className="text-gray-600">{customerData && customerData.crcardid}</span></p>
              <p className="text-sm text-gray-800">Customer Since: <span className="text-gray-600">{format(Date.parse(token.customerSince), "MM/dd/yyyy")}</span></p>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="bg-white px-12">
          {/* Table Title and Option */}
          <div className="flex items-center md:justify-between sm:justify-start mb-4">
            <h3 className="text-xl font-semibold text-gray-900">Recent Activity</h3>
            <select onChange={(e) => lastOrderIncludeChangeHandler(e)} value={lastOrderInclude} className="p-2 border border-gray-300 rounded-md text-gray-900 ">
              <option value="invoice">Invoices</option>
              <option value="order">Orders</option>
              <option value="all">All</option>
            </select>
          </div>
          {/* Table */}
          <div className="w-full overflow-x-auto">
            <div className="table-auto text-left border-collapse ">{renderLastTransaction()}</div>
          </div>
        </div>

      </div>
    );
  }

  const [profilePic, setProfilePic] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    title: "",
    email: "",
    phone: "",
    birthdate: "",
    option: "",
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const accountInfoOpen = () => {
    return (
      <div className="max-w-4xl mx-auto my-6 p-6 bg-gray-250 shadow-[1px_1px_2px_rgba(0,0,0,0.2)]  rounded-2xl">
        {/* Header Section */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h2 className="text-2xl font-bold text-gray-800">Account Information</h2>
            <p className="text-gray-600">Manage your personal details and update your profile.</p>
          </div>
          {/* Profile Image */}
          <div className="relative w-24 h-24">
            <label htmlFor="fileInput" className="cursor-pointer">
              <img
                src={profilePic || "https://i1.rgstatic.net/ii/profile.image/314621238415361-1452022956276_Q512/John-Mathiason.jpg"}
                alt="Profile"
                className="w-24 h-24 rounded-full object-cover border-2 border-gray-300"
              />
              <input type="file" id="fileInput" className="hidden" onChange={handleImageChange} />
              <p className="text-blue-400 flex justify-center items-center underline ">Edit</p>
            </label>
          </div>
        </div>

        {/* User Info Form */}
        <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700 font-medium">Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="w-full p-2 border rounded-md focus:outline-blue-500"
              placeholder="Enter full name"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium">Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              className="w-full p-2 border rounded-md focus:outline-blue-500"
              placeholder="Enter title"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium">Recovery Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full p-2 border rounded-md focus:outline-blue-500"
              placeholder="Enter recovery email"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium">Phone Number</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              className="w-full p-2 border rounded-md focus:outline-blue-500"
              placeholder="Enter phone number"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium">Birthdate</label>
            <input
              type="date"
              name="birthdate"
              value={formData.birthdate}
              onChange={handleChange}
              className="w-full p-2 border rounded-md focus:outline-blue-500"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium">Communication Preferences</label>
            <select
              name="option"
              value={formData.option}
              onChange={handleChange}
              className="w-full p-2 border rounded-md focus:outline-blue-500"
            >
              <option value="">Preferences</option>
              <option value="option1">Option 1</option>
              <option value="option2">Option 2</option>
              <option value="option3">Option 3</option>
            </select>
          </div>
        </form>

        {/* Save Button */}
        <div className="mt-6 text-right">
          <button className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600">
            Save Changes
          </button>
        </div>
      </div>
    )
  }

  <div className="accInfo-container">
    <div className="row1 lg:flex lg:px-8" >
      <div className="acc-title-des">
        <h1 className="acc-title">Account Information</h1>
        <div className="acc-des flex-col"><span>Below are options for customizing your</span>
          <span>account profile. Your name, login credentials,</span>
          <span>security options are set by administrator.</span>
        </div>
      </div>
      <div className="acc-img1 lg:relative lg:left-[70rem] "><img id="top-img" src="" alt="image" /></div>
    </div>
    <hr />

    <div className="row2">
      <h2 className="acc-contact">Contact Name Info</h2>
      <div className="acc-name">Name:   Micheal Hollingsworth</div>
      <div className="acc-login">Login:  mhollingsworth@cdmsoftware.com</div>
    </div>
    <div className="row3">
      <label className="acc-label">Profile Picture</label>
      <div className="acc-pro-text">Add a profile picture to personalize your account</div>
      <div className="acc-img2"><img className="accInfo-prof" src=" " alt=" " />
        <div><input type="file" name="file" onChange={handleImage} /> </div>
        <div className="pic-sub" onClick={submitImage}>Submit</div>
      </div>
    </div>
    <div className="row4">
      <label className="acc-label">Display Name</label>
      <input
        className="acc-input"
        type="text"
        id="display name"
      //  onChange={" "}
      />
    </div>
    <div className="row5">
      <label className="acc-label">Title</label>
      <input
        className="acc-input-title"
        type="text"
        id="display name"
      //  onChange={" "}
      />
    </div>
    <div className="row6">
      <label className="acc-label">Recovery Email</label>
      <input
        className="acc-input2"
        type="text"
        id="display name"
      //  onChange={" "}
      />
    </div>
    <div className="row7">
      <label className="label-phone">Recovery Phone</label>
      <input
        className="input-phone"
        type="text"
        id="display name"
      //  onChange={" "}
      />
      <div className="les">
        <p id="label-bd ">Birthday</p>
        <input type="date" className="input-bd"></input>
      </div>
    </div>
    <div className="row8">
      <label className="communication ">Communication Preferences</label>
      <select id="com-drop">
        <option value="email-text">Email & Text</option>
        <option value=" ">NUN & Nun</option>
        <option value=" ">NUN & NUN</option>
        <option value=" ">NUN & NUN</option>
      </select>
    </div>
  </div>



  const invoiceSearchHandler = (event) => {
    setInvoiceSearch(event.target.value.toUpperCase());
  };

  // const invoiceFiltered = currentInvoiceData.filter((row) =>
  //   Object.values(row).some((val) =>
  //     String(val).toUpperCase().includes(invoiceSearch)
  //   )
  // );
  const [invDataType, setInvDataType] = useState("allInv")
  const [invoiceData, setInvoiceData] = useState([]);
  const [invSoEl, setInvSoEl] = useState(null);
  const [DateEl, setDateEl] = useState(null);
  const [PymTermEl, setPymTermEl] = useState(null);
  const [subEl, setSubEl] = useState(null);
  const [dueDateEl, setDueDateEl] = useState(null);
  const [freightEl, setFreightEl] = useState(null);
  const [taxEl, setTaxEl] = useState(null);
  const [amountEl, setAmountEl] = useState(null);
  const [blncDueEl, setBlncDueEl] = useState(null);
  // const [filter, setFilter] = useState("");
  const [sourceInv, setSourceInv] = useState("");
  const [invDate, setInvDate] = useState("");
  const [pymTerm, setPymTerm] = useState("");
  const [subInv, setSubInv] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [freight, setFreight] = useState("");
  const [taxInv, setTaxInv] = useState("");
  const [amountInv, setAmountInv] = useState("");
  const [blncDue, setBlncDue] = useState("");


  const handleInvChange = (event, value) => {
    if (value === "InvSource") {
      setInvSoEl(event.currentTarget);
    } else if (value === "invDate") {
      setDateEl(event.currentTarget);
    } else if (value === "invPaymentTerm") {
      setPymTermEl(event.currentTarget);
    } else if (value === "invSubtotal") {
      setSubEl(event.currentTarget);
    } else if (value === "InvDueDate") {
      setDueDateEl(event.currentTarget);
    } else if (value === "freight") {
      setFreightEl(event.currentTarget);
    } else if (value === "invTax") {
      setTaxEl(event.currentTarget);
    } else if (value === "invAmount") {
      setAmountEl(event.currentTarget);
    } else if (value === "inBalanceDue") {
      setBlncDueEl(event.currentTarget);
    }
  };

  const handleInvClose = () => {
    setInvSoEl(null);
    setDateEl(null);
    setPymTermEl(null);
    setSubEl(null);
    setDueDateEl(null);
    setFreightEl(null);
    setTaxEl(null);
    setAmountEl(null);
    setBlncDueEl(null);
  };


  const sourceInvData = [...new Set(mergedInvData.map((item) => item.originString))];
  const invDateData = [...new Set(mergedInvData.map((item) => item.invodate))];
  const PymTermData = [...new Set(mergedInvData.map((item) => item.pymttype))];
  const subInvData = [...new Set(mergedInvData.map((item) => item.subtotal))];
  const orD = [...new Set(mergedInvData.map((item) => item.duedate))];
  const freightData = [...new Set(mergedInvData.map((item) => item.frtamnt))];
  const taxInvData = [...new Set(mergedInvData.map((item) => item.taxamnt))];
  const amountInvData = [...new Set(mergedInvData.map((item) => item.docamnt))];
  const blncDueData = [...new Set(mergedInvData.map((item) => item.duedate))];

  const invoiceFilter = mergedInvData.filter((row) => {
    const mcSource = sourceInv ? row.originString === sourceInv : true;
    // const mcInvDate = invDate ? row.invodate === invDate : true;
    const mcPymTerm = pymTerm ? row.pymttype === pymTerm : true;
    const mcInvSub = subInv ? row.subtotal === subInv : true;
    // const mcDueDate = dueDate ? row.duedate === dueDate : true;
    const mcFreight = freight ? row.frtamnt === freight : true;
    const mcInvTax = taxInv ? row.taxamnt === taxInv : true;
    const mcInvAmount = amountInv ? row.docamnt === amountInv : true;
    const mcBlncDue = blncDue ? row.duedate === blncDue : true;

    const matchesDate = invDate ? dateFormater1(row.invodate) === invDate : true;
    const mcDueDate = dueDate ? dateFormater1(row.duedate) === dueDate : true;

    // console.log(dateFormater1(row.invodate));
    const matchesSearch = Object.values(row).some((val) =>
      String(val).toUpperCase().includes(invoiceSearch.toUpperCase())
    );

    return mcSource && matchesSearch && mcPymTerm && matchesDate && mcInvSub && mcDueDate && mcFreight && mcInvTax && mcInvAmount && mcBlncDue;
  });


  const [invSort, setInvSort] = useState({ key: "inv", order: "chi" });


  const invoiceSort = (column) => {
    const newInvoice = invSort.key === column && invSort.order === "iar" ? "chi" : "iar";

    const invSortedData = [...invoiceFilter].sort((a, b) => {
      if (column === "invDate") {
        return newInvoice === "iar"
          ? new Date(a.invodate) - new Date(b.invodate)
          : new Date(b.invodate) - new Date(a.invodate);
      } else if (column === "invSource") {
        return newInvoice === "iar"
          ? a.originString.localeCompare(b.originString)
          : b.originString.localeCompare(a.originString);
      } else if (column === "invSubtotal") {
        return newInvoice === "iar" ? a.subtotal - b.subtotal : b.subtotal - a.subtotal;
      } else if (column === "invDueDate") {
        return newInvoice === "iar"
          ? new Date(a.duedate) - new Date(b.duedate)
          : new Date(b.duedate) - new Date(a.duedate);
      } else if (column === "invPymTerm") {
        return newInvoice === "iar" ? a.pymttype - b.pymttype : b.pymttype - a.pymttype;
      } else if (column === "invTax") {
        return newInvoice === "iar" ? a.taxamnt - b.taxamnt : b.taxamnt - a.taxamnt;
      } else if (column === "invAmount") {
        return newInvoice === "iar" ? a.docamnt - b.docamnt : b.docamnt - a.docamnt;
      } else {
        return newInvoice === "iar" ? a.docamnt - b.docamnt : b.docamnt - a.docamnt;
      }
    });

    setInvoiceData(invSortedData);
    setInvSort({ key: column, order: newInvoice });
  };


  const invoicesOpen = () => {

    return (
      <>
        <TextField
          label="Search for invoice number.."
          variant="outlined"
          value={invoiceSearch}
          onChange={invoiceSearchHandler}
          fullWidth
          margin="normal"
        />
        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none', maxHeight: 630 }}>
          <Table aria-label="collapsible table" sx={{ border: 'none', }}>
            <TableHead sx={{ backgroundColor: "#cccccc" }}>
              <TableRow style={{ height: "4rem" }} >
                <TableCell padding='none' />
                <TableCell padding='none' width={200}>Invoice Number</TableCell>
                <TableCell padding='none' width={200} ><SwapVertIcon onClick={() => { setInvDataType("sorted"); invoiceSort("invSource") }} />Source<ArrowDropDownIcon onClick={(e) => { setInvDataType("filtered"); handleInvChange(e, "InvSource") }} /></TableCell>
                <TableCell padding='none' width={270}  ><SwapVertIcon onClick={() => { setInvDataType("sorted"); invoiceSort("invDate") }} />Invoice Date<ArrowDropDownIcon onClick={(e) => { setInvDataType("filtered"); handleInvChange(e, "invDate") }} /></TableCell>
                <TableCell padding='none' width={450}  ><SwapVertIcon onClick={() => { setInvDataType("sorted"); invoiceSort("invPymTerm") }} />Payment Type<ArrowDropDownIcon onClick={(e) => { setInvDataType("filtered"); handleInvChange(e, "invPaymentTerm") }} /></TableCell>
                <TableCell padding='none' width={200}  ><SwapVertIcon onClick={() => { setInvDataType("sorted"); invoiceSort("invSubtotal") }} />Subtotal<ArrowDropDownIcon onClick={(e) => { setInvDataType("filtered"); handleInvChange(e, "invSubtotal") }} /></TableCell>
                <TableCell padding='none' width={200}  ><SwapVertIcon onClick={() => { setInvDataType("sorted"); invoiceSort("invDueDate") }} />Due Date<ArrowDropDownIcon onClick={(e) => { setInvDataType("filtered"); handleInvChange(e, "InvDueDate") }} /></TableCell>
                <TableCell padding='none' width={200}  ><SwapVertIcon onClick={() => { setInvDataType("sorted"); invoiceSort("invTax") }} />Tax<ArrowDropDownIcon onClick={(e) => { setInvDataType("filtered"); handleInvChange(e, "invTax") }} /></TableCell>
                <TableCell padding='none' width={370}  ><SwapVertIcon onClick={() => { setInvDataType("sorted"); invoiceSort("invAmount") }} /> Amount<ArrowDropDownIcon onClick={(e) => { setInvDataType("filtered"); handleInvChange(e, "invAmount") }} /></TableCell>
                <TableCell padding='none' width={360}  ><SwapVertIcon onClick={() => { setInvDataType("sorted"); invoiceSort("balance") }} />Balance Due<ArrowDropDownIcon onClick={(e) => { setInvDataType("filtered"); handleInvChange(e, "inBalanceDue") }} /></TableCell>
                <TableCell padding='none' width={200} >Order Now</TableCell>
                <TableCell padding='none' width={200}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invDataType === "filtered" ? invoiceFilter.map((invoice, index) => (
                <InvoiceRow key={index} invoice={invoice}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              )) : invDataType === "sorted" ? invoiceData.map((invoice, index) => (
                <InvoiceRow key={index} invoice={invoice}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              )) : mergedInvData.map((invoice, index) => (
                <InvoiceRow key={index} invoice={invoice}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              ))}

            </TableBody>
          </Table>

          {/* Filter Dropdown */}

          <Menu anchorEl={invSoEl} open={Boolean(invSoEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => {
              setSourceInv(null);
              setInvoiceSearch("");
              setInvSoEl(null);
            }}>All</MenuItem>
            {sourceInvData.map((originString) => (
              <MenuItem key={originString} onClick={() => {
                setSourceInv(originString);
                setInvSoEl(null);
              }}>
                {originString}
              </MenuItem>
            ))}
          </Menu>


          {/* Order Date */}

          <Menu anchorEl={DateEl} open={Boolean(DateEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => setInvDate(null)}>Reset</MenuItem>
            <MenuItem disableRipple>
              <TextField
                type="date"
                value={invDate}
                onChange={(e) => setInvDate(e.target.value)}
                autoFocus
              />
            </MenuItem>
          </Menu>


          {/* Locations */}

          <Menu anchorEl={PymTermEl} open={Boolean(PymTermEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => {
              setPymTerm(null);
              setInvoiceSearch("");
              setPymTermEl(null);
            }}>All</MenuItem>
            {PymTermData.map((pymttype) => (
              <MenuItem key={pymttype} onClick={() => {
                setPymTerm(pymttype);
                setPymTermEl(null);
              }}>
                {pymttype === 1 ? "Cash Deposit " : pymttype === 2 ? "Check Deposit" : pymttype === 3 ? "Credit Card Deposit" :
                  pymttype === 4 ? "Cash Payment" : pymttype === 5 ? "Check Payment" : pymttype === 6 ? "Credit Card Payment" : pymttype}
              </MenuItem>
            ))}
          </Menu>

          <Menu anchorEl={subEl} open={Boolean(subEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => {
              setSubInv(null);
              setInvoiceSearch("");
              setSubEl(null);
            }}>All</MenuItem>
            {subInvData.map((subtotal) => (
              <MenuItem key={subtotal} onClick={() => {
                setSubInv(subtotal);
                setSubEl(null);
              }}>
                {subtotal}
              </MenuItem>
            ))}
          </Menu>


          <Menu anchorEl={dueDateEl} open={Boolean(dueDateEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => setDueDate(null)}>Reset</MenuItem>
            <MenuItem disableRipple>
              <TextField
                type="date"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
                autoFocus
              />
            </MenuItem>
          </Menu>


          <Menu anchorEl={freightEl} open={Boolean(freightEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => {
              setFreight(null);
              setInvoiceSearch("");
              setFreightEl(null);
            }}>All</MenuItem>
            {freightData.map((frtamnt) => (
              <MenuItem key={frtamnt} onClick={() => {
                setFreight(frtamnt);
                setFreightEl(null);
              }}>
                {frtamnt}
              </MenuItem>
            ))}
          </Menu>
          <Menu anchorEl={taxEl} open={Boolean(taxEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => {
              setTaxInv(null);
              setInvoiceSearch("");
              setTaxEl(null);
            }}>All</MenuItem>
            {taxInvData.map((taxamnt) => (
              <MenuItem key={taxamnt} onClick={() => {
                setTaxInv(taxamnt);
                setTaxEl(null);
              }}>
                {taxamnt}
              </MenuItem>
            ))}
          </Menu>
          <Menu anchorEl={amountEl} open={Boolean(amountEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => {
              setAmountInv(null);
              setInvoiceSearch("");
              setAmountEl(null);
            }}>All</MenuItem>
            {amountInvData.map((docamnt) => (
              <MenuItem key={docamnt} onClick={() => {
                setAmountInv(docamnt);
                setAmountEl(null);
              }}>
                {docamnt}
              </MenuItem>
            ))}
          </Menu>
          <Menu anchorEl={blncDueEl} open={Boolean(blncDueEl)} onClose={handleInvClose}>
            <MenuItem onClick={() => {
              setBlncDue(null);
              setInvoiceSearch("");
              setBlncDueEl(null);
            }}>All</MenuItem>
            {blncDueData.map((duedate) => (
              <MenuItem key={duedate} onClick={() => {
                setBlncDue(duedate);
                setBlncDueEl(null);
              }}>
                {duedate}
              </MenuItem>
            ))}
          </Menu>



        </TableContainer>
      </>

    )
  };


  // console.log(currentInvoiceData)

  const orderSearchHandler = (event) => {
    setSearchTerm(event.target.value.toUpperCase());
  };

  // const orderFiltered = currentOrderData.filter((row) =>
  //   Object.values(row).some((val) =>
  //     String(val).toUpperCase().includes(searchTerm)
  //   )
  // );
  const [viewType, setViewType] = useState("all"); // 'all', 'filtered', 'sorted'
  const [anchorEl, setAnchorEl] = useState(null);
  const [anDate, setAnDate] = useState(null);
  const [anSite, setAnSite] = useState(null);
  const [anDueDate, setAnDueDate] = useState(null);
  const [anAmount, setAnAmount] = useState(null);
  const [anName, setAnName] = useState(null);
  const [anStatus, setAnStatus] = useState(null);
  // const [filter, setFilter] = useState("");
  const [source, setSource] = useState("");
  const [siteId, setSideId] = useState("");
  const [orderDate, setOrderDate] = useState("");
  const [orDueDate, setOrDueDate] = useState("");
  const [amount, setAmount] = useState("");
  const [name, setName] = useState("");
  const [orderStatus, setOrderStatus] = useState("");
  const [isSource, setIsSource] = useState(false);

  const sourceData = [...new Set(currentOrderData.map((item) => item.origin))];
  const orderDateData = [...new Set(currentOrderData.map((item) => item.ordrdate))];
  const siteIdData = [...new Set(currentOrderData.map((item) => item.locncode))];
  const orDueDateData = [...new Set(currentOrderData.map((item) => item.duedate))];
  const amountData = [...new Set(currentOrderData.map((item) => item.docamnt))];
  const nameData = [...new Set(currentOrderData.map((item) => item.custname))];
  const orderStatusData = [...new Set(currentOrderData.map((item) => item.status))];

  const handleSource = (event, value) => {
    if (value === "source") {

      setAnchorEl(event.currentTarget);
    } else if (value === "orderDate") {
      setAnDate(event.currentTarget);
    } else if (value === "siteId") {
      setAnSite(event.currentTarget);
    } else if (value === "dueDate") {
      setAnDueDate(event.currentTarget);
    } else if (value === "amount") {
      setAnAmount(event.currentTarget);
    } else if (value === "name") {
      setAnName(event.currentTarget);
    } else if (value === "orderStatus") {
      setAnStatus(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnDate(null);
    setAnSite(null);
    setAnDueDate(null);
    setAnAmount(null);
    setAnName(null);
    setAnStatus(null);
  };

  const orderFiltered = currentOrderData.filter((row) => {
    const matchesSource = source ? row.origin === source : true;
    const siteIds = siteId ? row.locncode === siteId : true;
    const amounts = amount ? row.docamnt === amount : true;
    const allNames = name ? row.custname === name : true;
    const orStatus = orderStatus ? row.status === orderStatus : true;

    const matchesDate = orderDate ? dateFormater1(row.ordrdate) === orderDate : true;
    const matchesDueDate = orDueDate ? dateFormater1(row.duedate) === orDueDate : true;

    // console.log(dateFormater1(row.ordrdate));
    const matchesSearch = Object.values(row).some((val) =>
      String(val).toUpperCase().includes(searchTerm.toUpperCase())
    );

    return matchesSource && matchesSearch && siteIds && matchesDate && amounts && allNames && orStatus && matchesDueDate;
  });



  const [sortConfig, setSortConfig] = useState({ key: "date", order: "desc" });


  const handleSort = (column) => {
    const newOrder = sortConfig.key === column && sortConfig.order === "asc" ? "desc" : "asc";

    const sortedData = [...orderFiltered].sort((a, b) => {
      if (column === "orderDate") {
        return newOrder === "asc"
          ? new Date(a.ordrdate) - new Date(b.ordrdate)
          : new Date(b.ordrdate) - new Date(a.ordrdate);
      } else if (column === "source") {
        return newOrder === "asc" ? a.origin - b.origin : b.origin - a.origin;
      } else if (column === "orderAmount") {
        return newOrder === "asc" ? a.docamnt - b.docamnt : b.docamnt - a.docamnt;
      } else if (column === "dueDate") {
        return newOrder === "asc"
          ? new Date(a.duedate) - new Date(b.duedate)
          : new Date(b.duedate) - new Date(a.duedate);
      } else if (column === "orderName") {
        return newOrder === "asc"
          ? a.custname.localeCompare(b.custname)
          : b.custname.localeCompare(a.custname);
      } else if (column === "orderStatus") {
        return newOrder === "asc"
          ? a.status.localeCompare(b.status)
          : b.status.localeCompare(a.status);
      } else {
        return newOrder === "asc"
          ? a.locncode.localeCompare(b.locncode)
          : b.locncode.localeCompare(a.locncode);
      }
    });

    setOrderData(sortedData);
    setSortConfig({ key: column, order: newOrder });
  };

  const ordersOpen = () => {

    //        const columns = [
    //         {header: 'Order Number',key: 'sopnumbe',td: (data) => <div className = 'bold' onClick={() => handleItemDetails(data.sopnumbe)}>{data.sopnumbe}</div>},
    //         {header: 'Order Date',key: 'ordrdate', td: (data) => <div>{format(Date.parse(data.ordrdate), "MM/dd/yyyy")}</div>},
    //         {header: 'Origin',key: 'origin',},
    //         {header: "Site ID", key: "locncode", td: (data) => <div>{data.locncode}</div>},
    //         {header: 'Due Date',key: 'duedate', td: (data) => <div>{format(Date.parse(data.duedate), "MM/dd/yyyy")}</div>},
    //         {header: 'Order Amount',key: 'docamnt',td: (data) => <div>{formatter.format(data.docamnt)}</div>},
    //         {header: 'Name', key: 'custname'},          
    //         {header: 'Order Status',key: 'status'},
    //         {header: 'Order Now', td: (data) => <div className = 'flex-col' onClick={() => reOrderItems(data.sopnumbe)}>REORDER</div>},  
    //         {header: 'Actions', td: (data) => <div className = 'flex-col'><img src={SaveLogo} width='30' height='30' 
    //         onClick={() => getReport(data.sopnumbe,"Order","Order")}/></div>}
    //     ];
    // if(viewOrders){    
    // if(!currentOrderData){
    //     return <h2>Awaiting Order Data.... If this is more than 5 seconds, you may not have any open orders</h2>;}else{
    //         return <ReactFlexyTable  data={currentOrderData} columns = {columns} 
    //             sortable filterable showExcelButton downloadExcelProps={downloadExcelProps}></ReactFlexyTable>;
    //     }
    // }



    return (
      <>
        <TextField
          label="Search for order number.."
          variant="outlined"
          value={searchTerm}
          onChange={orderSearchHandler}
          fullWidth
          margin="normal"
        />
        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none', maxHeight: 630 }}>
          <Table id="myTable" aria-label="collapsible table" sx={{ border: 'none', }}>
            <TableHead sx={{ backgroundColor: "#cccccc" }}>
              <TableRow>
                <TableCell />
                <TableCell>Order Number</TableCell>
                <TableCell align="left" ><SwapVertIcon onClick={() => { setViewType("sorted"); handleSort("source") }} />Source<ArrowDropDownIcon onClick={(e) => { setViewType("filtered"); handleSource(e, "source") }} />
                </TableCell>
                <TableCell align="left" ><SwapVertIcon onClick={() => handleSort("orderDate")} />Order Date<ArrowDropDownIcon onClick={(e) => handleSource(e, "orderDate")} /></TableCell>
                <TableCell align="left" ><SwapVertIcon onClick={() => handleSort("siteId")} />Site ID<ArrowDropDownIcon onClick={(e) => handleSource(e, "siteId")} /></TableCell>
                <TableCell align="left" ><SwapVertIcon onClick={() => handleSort("dueDate")} />Due Date<ArrowDropDownIcon onClick={(e) => handleSource(e, "dueDate")} /></TableCell>
                <TableCell align="left" ><SwapVertIcon onClick={() => handleSort("orderAmount")} />Order Amount<ArrowDropDownIcon onClick={(e) => handleSource(e, "amount")} /></TableCell>
                <TableCell align="left" ><SwapVertIcon onClick={() => handleSort("orderName")} />Name<ArrowDropDownIcon onClick={(e) => handleSource(e, "name")} /></TableCell>
                <TableCell align="left" ><SwapVertIcon onClick={() => handleSort("orderStatus")} />Order Status<ArrowDropDownIcon onClick={(e) => handleSource(e, "orderStatus")} /></TableCell>
                <TableCell align="left" >Order Now</TableCell>
                <TableCell align="left" >Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody >
              {viewType === "filtered" ? orderFiltered.map((order, index) => (
                <OrderRow key={index} order={order}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              )) : viewType === "sorted" ? orderData.map((order, index) => (
                <OrderRow key={index} order={order}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              )) : currentOrderData.map((order, index) => (
                <OrderRow key={index} order={order}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              ))}

            </TableBody>
          </Table>
          {/* Filter Dropdown */}

          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem onClick={() => {
              setSource(null);
              setSearchTerm("");
              setAnchorEl(null);
            }}>All</MenuItem>
            {sourceData.map((origin) => (
              <MenuItem key={origin} onClick={() => {
                setSource(origin);
                setAnchorEl(null);
              }}>
                {origin === 1 ? "In Store" : origin === 3 ? "Online" : origin === 2 ? "POS" : origin === 0 ? "Unknown" : origin}
              </MenuItem>
            ))}
          </Menu>


          {/* Order Date */}

          <Menu anchorEl={anDate} open={Boolean(anDate)} onClose={handleClose}>
            <MenuItem onClick={() => { setOrderDate(null); }}>Reset</MenuItem>
            <MenuItem disableRipple>
              <TextField
                type="date"
                value={orderDate}
                onChange={(e) => setOrderDate(e.target.value)}
                autoFocus
              />
            </MenuItem>
          </Menu>


          {/* Locations */}

          <Menu anchorEl={anSite} open={Boolean(anSite)} onClose={handleClose}>
            <MenuItem onClick={() => {
              setSideId(null);
              setSearchTerm("");
              setAnSite(null);
            }}>All</MenuItem>
            {siteIdData.map((locncode) => (
              <MenuItem key={locncode} onClick={() => {
                setSideId(locncode);
                setAnSite(null);
              }}>
                {locncode}
              </MenuItem>
            ))}
          </Menu>

          <Menu anchorEl={anDueDate} open={Boolean(anDueDate)} onClose={handleClose}>
            <MenuItem onClick={() => { setOrDueDate(null); }}>Reset</MenuItem>
            <MenuItem disableRipple>
              <TextField
                type="date"
                value={orDueDate}
                onChange={(e) => setOrDueDate(e.target.value)}
                autoFocus
              />
            </MenuItem>
          </Menu>



          {/* Amounts */}

          <Menu anchorEl={anAmount} open={Boolean(anAmount)} onClose={handleClose}>
            <MenuItem onClick={() => {
              setAmount(null);
              setSearchTerm("");
              setAnAmount(null);
            }}>All</MenuItem>
            {amountData.map((docamnt) => (
              <MenuItem key={docamnt} onClick={() => {
                setAmount(docamnt);
                setAnAmount(null);
              }}>
                {docamnt}
              </MenuItem>
            ))}
          </Menu>


          {/* Customer Name */}

          <Menu anchorEl={anName} open={Boolean(anName)} onClose={handleClose}>
            <MenuItem onClick={() => {
              setName(null);
              setSearchTerm("");
              setAnName(null);
            }}>All</MenuItem>
            {nameData.map((custname) => (
              <MenuItem key={custname} onClick={() => {
                setName(custname);
                setAnName(null);
              }}>
                {custname}
              </MenuItem>
            ))}
          </Menu>


          {/* Order Status */}

          <Menu anchorEl={anStatus} open={Boolean(anStatus)} onClose={handleClose}>
            <MenuItem onClick={() => {
              setOrderStatus(null);
              setSearchTerm("");
              setAnStatus(null);
            }}>All</MenuItem>
            {orderStatusData.map((status) => (
              <MenuItem key={status} onClick={() => {
                setOrderStatus(status);
                setAnStatus(null);
              }}>
                {status}
              </MenuItem>
            ))}
          </Menu>

        </TableContainer>
      </>

    )
  };


  const quoteSearchHandler = (event) => {
    setQuoteSearch(event.target.value.toUpperCase());
  };

  const [quoteData, setQuoteData] = useState([]);
  const [qtDataType, setQtDataType] = useState("allqt");

  const [sortQuotes, setSortQuotes] = useState("desc");
  const [quoteDateQ, setQuoteDateQ] = useState(null);
  const [quoteAmountQ, setQouteAmountQ] = useState(null);
  const [qtNameQ, setQtNameQ] = useState(null);
  // const [filter, setFilter] = useState("");
  const [qtDate, setQtDate] = useState("");
  const [qtAmount, setQtAmount] = useState("");
  const [qtName, setQtName] = useState("");


  const qtDateData = [...new Set(currentQuoteData.map((item) => item.quotedat))];
  const qtAmountData = [...new Set(currentQuoteData.map((item) => item.docamnt))];
  const qtNameData = [...new Set(currentQuoteData.map((item) => item.custname))];


  const handleQuotesChange = (event, value) => {
    if (value === "qtDate") {
      setQuoteDateQ(event.currentTarget);
    } else if (value === "qtAmount") {
      setQouteAmountQ(event.currentTarget);
    } else if (value === "qtName") {
      setQtNameQ(event.currentTarget);
    }
  };

  const handleQuotesClose = () => {
    setQuoteDateQ(null);
    setQouteAmountQ(null);
    setQtNameQ(null);

  };

  const quotesFilter = currentQuoteData.filter((row) => {
    const macQtName = qtName ? row.custname === qtName : true;
    const macQtAmount = qtAmount ? row.docamnt === qtAmount : true;

    const macQtDate = qtDate ? dateFormater1(row.quotedat) === qtDate : true;

    // console.log(dateFormater1(row.ordrdate));
    const matchesSearch = Object.values(row).some((val) =>
      String(val).toUpperCase().includes(searchTerm.toUpperCase())
    );

    return macQtDate && matchesSearch && macQtName && macQtAmount;
  });


  const [quoteSort, setQuoteSort] = useState({ key: "quote", order: "qt" });


  const quoteSortHandler = (column) => {
    const newQuote = quoteSort.key === column && quoteSort.order === "cte" ? "qt" : "cte";

    const sortedQuote = [...quotesFilter].sort((a, b) => {
      if (column === "quoteDate") {
        return newQuote === "cte"
          ? new Date(a.quotedat) - new Date(b.quotedat)
          : new Date(b.quotedat) - new Date(a.quotedat);
      } else if (column === "quoteAmount") {
        return newQuote === "cte" ? a.docamnt - b.docamnt : b.docamnt - a.docamnt;
      } else if (column === "quoteName") {
        return newQuote === "cte"
          ? a.custname.localeCompare(b.custname)
          : b.custname.localeCompare(a.custname);
      }
    });

    setQuoteData(sortedQuote);
    setQuoteSort({ key: column, order: newQuote });
  };



  const quotesOpen = () => {


    return (
      <>
        <TextField
          label="Search for quote number.."
          variant="outlined"
          value={quoteSearch}
          onChange={quoteSearchHandler}
          fullWidth
          margin="normal"
        />
        <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none', maxHeight: 630 }}>
          <Table aria-label="collapsible table" sx={{ border: 'none', }}>
            <TableHead sx={{ backgroundColor: "#cccccc" }}>
              <TableRow>
                <TableCell />
                <TableCell>Quote Number</TableCell>
                <TableCell align="right"><SwapVertIcon onClick={() => { setQtDataType("sorted"); quoteSortHandler("quoteDate") }} />Quote Date<ArrowDropDownIcon onClick={(e) => { setQtDataType("filtered"); handleQuotesChange(e, "qtDate") }} /></TableCell>
                <TableCell align="right"><SwapVertIcon onClick={() => { setQtDataType("sorted"); quoteSortHandler("quoteAmount") }} />Quote Amount<ArrowDropDownIcon onClick={(e) => { setQtDataType("filtered"); handleQuotesChange(e, "qtAmount") }} /></TableCell>
                <TableCell align="right"><SwapVertIcon onClick={() => { setQtDataType("sorted"); quoteSortHandler("quoteName") }} />Name<ArrowDropDownIcon onClick={(e) => { setQtDataType("filtered"); handleQuotesChange(e, "qtName") }} /></TableCell>
                <TableCell align="right">Order Now</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {qtDataType === "filtered" ? quotesFilter.map((quote, index) => (
                <QuoteRow key={index} quote={quote}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              )) : qtDataType === "sorted" ? quoteData.map((quote, index) => (
                <QuoteRow key={index} quote={quote}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              )) : currentQuoteData.map((quote, index) => (
                <QuoteRow key={index} quote={quote}
                  childColumn={itemDetailsColumns}
                  reOrderItems={reOrderItems}
                  getReport={getReport}
                />
              ))}

            </TableBody>
          </Table>
          {/* Order Date */}

          <Menu anchorEl={quoteDateQ} open={Boolean(quoteDateQ)} onClose={handleQuotesClose}>
            <MenuItem onClick={() => { setQtDate(null); }}>Reset</MenuItem>
            <MenuItem disableRipple>
              <TextField
                type="date"
                value={qtDate}
                onChange={(e) => setQtDate(e.target.value)}
                autoFocus
              />
            </MenuItem>
          </Menu>

          <Menu anchorEl={quoteAmountQ} open={Boolean(quoteAmountQ)} onClose={handleQuotesClose}>
            <MenuItem onClick={() => {
              setQtAmount(null);
              setQuoteSearch("");
              setQouteAmountQ(null);
            }}>All</MenuItem>
            {qtAmountData.map((docamnt) => (
              <MenuItem key={docamnt} onClick={() => {
                setQtAmount(docamnt);
                setQouteAmountQ(null);
              }}>
                {docamnt}
              </MenuItem>
            ))}
          </Menu>

          <Menu anchorEl={qtNameQ} open={Boolean(qtNameQ)} onClose={handleQuotesClose}>
            <MenuItem onClick={() => {
              qtName(null);
              setQuoteSearch("");
              setQtNameQ(null);
            }}>All</MenuItem>
            {qtNameData.map((custname) => (
              <MenuItem key={custname} onClick={() => {
                qtName(custname);
                setQtNameQ(null);
              }}>
                {custname}
              </MenuItem>
            ))}
          </Menu>

        </TableContainer>
      </>

    )


  };

  const renderLastTransaction = () => {

    if (lastOrderInclude === 'order') {
      return (
        <Paper sx={{ width: '100%', overflow: 'hidden', }}>
          <TableContainer sx={{ maxHeight: 440, }}>
            <Table stickyHeader aria-label="sticky table" sx={{ border: 'none', boxShadow: 'none' }}>
              <TableHead>
                <TableRow>
                  {orderColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {lastOrder
                  .map((recentOrder, index) => {
                    return (
                      <TableRow >
                        <TableCell key={index}>
                          <label className="d-trx"><span className="trx-s">{recentOrder ? recentOrder.sopnumbe : "None"}</span></label>
                        </TableCell>
                        <TableCell key={index}>
                          <label className="d-type"><span>order</span></label>
                        </TableCell>
                        <TableCell key={index}>
                          <label className="d-type"><span>{recentOrder.origin === 1 ? "In Store" : recentOrder.origin === 3 ? "Online" : recentOrder.origin}</span></label>
                        </TableCell>
                        <TableCell>
                          <label className="trx-date"><span className="d-date-s">{recentOrder ? format(Date.parse(recentOrder.ordrdate), "MM/dd/yyyy") : "None"}</span></label>
                        </TableCell>
                        <TableCell>
                          <label className="po"><span>4455</span></label>
                        </TableCell>
                        <TableCell>
                          <label className="trx-total ml-4"><span className="d-total-s">{recentOrder ? formatter.format(recentOrder.docamnt) : "None"}</span></label>
                        </TableCell>
                        <TableCell>
                          <label className="or-status"><div className="flex-row"><di>{recentOrder.status}</di><div><a className="mx-2" href={`https://www.ups.com/track?tracknum=${recentOrder.trackingNumber}`} ><span>Track: {recentOrder.trackingNumber}</span></a></div></div></label>
                        </TableCell>
                        <TableCell>
                          <Button
                            sx={{ fontSize: 13, height: 23 }}
                            variant="contained"
                            color="primary"
                            onClick={() => reOrderItems(recentOrder.sopnumbe)}
                          >
                            REORDER
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>

      );
    } else if (lastOrderInclude === "invoice") {
      return (
        <div className="dash-table">
          <Paper sx={{ width: '100%', overflow: 'hidden', background: "" }}>
            <TableContainer sx={{ maxHeight: 440, }}>
              <Table stickyHeader aria-label="sticky table" sx={{ border: 'none', boxShadow: 'none' }}>
                <TableHead>
                  <TableRow>
                    {invoiceColumn.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {lastInvoice
                    .map((recentInvoice, index) => {
                      return (
                        <TableRow key={index} >
                          <TableCell >
                            <label className="d-trx "><span className="trx-s">{!!recentInvoice ? recentInvoice.sopnumbe : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="d-type "><span>Invoice</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="d-type "><span>{recentInvoice ? recentInvoice.originString : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="trx-date ml-[1rem] "><span className="d-date-s">{!!recentInvoice ? formatDate(recentInvoice.invodate) : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="po"><span>4455</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="trx-total  "><span className="d-total-s">{!!recentInvoice ? formatter.format(recentInvoice.docamnt) : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="or-status"><div className="flex-row"><di>{recentInvoice.status}</di><div><a className="mx-2" href={`https://www.ups.com/track?tracknum=${recentInvoice.trackingNumber}`} ><span>Track</span></a></div></div></label>
                          </TableCell>
                          <TableCell>
                            <Button
                              sx={{ fontSize: 13, height: 23 }}
                              variant="contained"
                              color="primary"
                              onClick={() => reOrderItems(recentInvoice.sopnumbe)}
                            >
                              REORDER
                            </Button>
                          </TableCell>
                          <TableCell>
                            {recentInvoice.acctamnt <= 0 ? (
                              <div className="flex space-x-2">
                                <img
                                  src={SaveLogo}
                                  width='30'
                                  height='30'
                                  onClick={() => getReport(recentInvoice.sopnumbe, "Invoice_Posted", "PostedInvoice")}
                                />
                                <img
                                  src={paidLogo}
                                  width='50'
                                  height='50'
                                />
                              </div>) :

                              recentInvoice.docamnt > 0.01 ? (
                                <div className='flex-row space-x-3'>
                                  <div className=' cursor-pointer'>
                                    <img
                                      src={SaveLogo}
                                      width='30'
                                      height='30'
                                      onClick={() => getReport(recentInvoice.sopnumbe, "Invoice_Posted", "PostedInvoice")}
                                    />
                                  </div>
                                  <div className='cursor-pointer'>
                                    <a href="https://primepowerserv.securepayments.cardpointe.com/pay?"
                                      target="_blank"
                                      rel="noreferrer noopener">
                                      <img
                                        src={PayLogo}
                                        width='30'
                                        height='30'
                                      /></a>
                                  </div>
                                </div>
                              ) : (
                                <div className='flex-row'>
                                  <div className='flex-col'>
                                    <img
                                      src={SaveLogo}
                                      width='30'
                                      height='30'
                                      onClick={() => getReport(recentInvoice.sopnumbe, "Invoice_Posted", "PostedInvoice")}
                                    />
                                  </div>
                                </div>
                              )
                            }
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
          </Paper>
        </div>
      );
    } else if (lastOrderInclude === "all") {
      return (
        <div className="dash-table">
          <Paper sx={{ width: '100%', overflow: 'hidden', background: "" }}>
            <TableContainer sx={{ maxHeight: 440, }}>
              <Table stickyHeader aria-label="sticky table" sx={{ border: 'none', boxShadow: 'none' }}>
                <TableHead>
                  <TableRow>
                    {all.map((column) => (
                      <TableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {lastInvoice
                    .map((data, index) => {
                      return (
                        <TableRow key={index} >
                          <TableCell >
                            <label className="d-trx "><span className="trx-s">{!!data ? data.sopnumbe : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="d-type "><span>Invoice</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="d-type "><span>{data.origin === 1 ? "In Store" : data.origin === 3 ? "Online" : data.origin}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="trx-date ml-[1rem] "><span className="d-date-s">{!!data ? formatDate(data.invodate) : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="po"><span>4455</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="trx-total  "><span className="d-total-s">{!!data ? formatter.format(data.docamnt) : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="or-status"><div className="flex-row"><di>{data.status}</di><div><a className="mx-2" href={`https://www.ups.com/track?tracknum=${data.trackingNumber}`} ><span>Track</span></a></div></div></label>
                          </TableCell>
                          <TableCell>
                            <Button
                              sx={{ fontSize: 13, height: 23 }}
                              variant="contained"
                              color="primary"
                              onClick={() => reOrderItems(data.sopnumbe)}
                            >
                              REORDER
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {lastOrder
                    .map((recentOrder, index) => {
                      return (
                        <TableRow >
                          <TableCell key={index}>
                            <label className="d-trx"><span className="trx-s">{recentOrder ? recentOrder.sopnumbe : "None"}</span></label>
                          </TableCell>
                          <TableCell key={index}>
                            <label className="d-type"><span>order</span></label>
                          </TableCell>
                          <TableCell key={index}>
                            <label className="d-type"><span>{recentOrder.origin === 1 ? "In Store" : recentOrder.origin === 3 ? "Online" : recentOrder.origin}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="trx-date"><span className="d-date-s">{recentOrder ? format(Date.parse(recentOrder.ordrdate), "MM/dd/yyyy") : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="po"><span>4455</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="trx-total ml-4"><span className="d-total-s">{recentOrder ? formatter.format(recentOrder.docamnt) : "None"}</span></label>
                          </TableCell>
                          <TableCell>
                            <label className="or-status"><div className="flex-row"><di>{recentOrder.status}</di><div><a className="mx-2" href={`https://www.ups.com/track?tracknum=${recentOrder.trackingNumber}`} ><span>Track: {recentOrder.trackingNumber}</span></a></div></div></label>
                          </TableCell>
                          <TableCell>
                            <Button
                              sx={{ fontSize: 13, height: 23 }}
                              variant="contained"
                              color="primary"
                              onClick={() => reOrderItems(recentOrder.sopnumbe)}
                            >
                              REORDER
                            </Button>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
            {/* <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={rows.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    /> */}
          </Paper>
        </div>
      );
    }

  }




  const dataSelection = () => {
    return (
      <div className='portal-cover md:p-[2em]'>
        <div className="invoice">
          {viewInvoices && invoicesOpen()}
        </div>
        {viewOrders && ordersOpen()}
        {viewQuotes && quotesOpen()}
        {viewDashboard && dashboardOpen()}
        {accInfo && accountInfoOpen()}
        {viewItemDetails && itemDetails()}
      </div>);
  }

  const DrawerList = (

    <div>

      {/* Drawer Panel */}
      <div
        className={`fixed top-0 left-0 h-full w-80 bg-white shadow-lg transform transition-transform overflow-y-auto ${isOpen ? "translate-x-0" : "-translate-x-full"
          }`}
        onClick={toggleDrawer(false)}
      >
        {/* Drawer Header */}
        <div className="flex justify-between items-center p-3 h-[4.5rem] bg-gray-800 text-white">
          <h3 className="text-lg font-semibold">
            <FontAwesomeIcon icon={faUser} className="mr-2" />
            Welcome, {token.customerName}!
          </h3>
        </div>

        {/* Drawer Content */}
        <div className="p-4 space-y-4">
          <h3 className="text-lg font-semibold">{selectionHeader}</h3>
          <p className="text-sm text-gray-600">{selectionDescription}</p>

          {/* Navigation Links */}
          <hr />
          <ul className="space-y-3">
            <li className="cursor-pointer text-gray-700 hover:text-blue-500" onClick={showDashboard}>Dashboard</li>
            <li className="cursor-pointer text-gray-700 hover:text-blue-500" onClick={showInvoices}>Invoices</li>
            <li className="cursor-pointer text-gray-700 hover:text-blue-500" onClick={showOrders}>Orders</li>
            <li className="cursor-pointer text-gray-700 hover:text-blue-500" onClick={showQuotes}>Quotes</li>
            <li className="cursor-pointer text-gray-700 hover:text-blue-500">Payment Methods</li>
            <li className="cursor-pointer text-gray-700 hover:text-blue-500">Lists</li>
            <li className="cursor-pointer text-red-500 font-semibold hover:text-red-700" onClick={signOut}>Sign-Out</li>
          </ul>

          {/* Rewards Section */}
          <hr />
          <h5 className="text-lg font-semibold">
            <FontAwesomeIcon icon={faGift} className="mr-2" />
            Rewards
          </h5>
          <ul className="space-y-3">
            <li className="cursor-pointer text-gray-700 hover:text-blue-500">Overview</li>
            <li className="cursor-pointer text-gray-700 hover:text-blue-500">Super Rewards</li>
          </ul>

          {/* My Activity Section */}
          <hr />
          <h5 className="text-lg font-semibold">
            <FontAwesomeIcon icon={faStar} className="mr-2" />
            My Activity
          </h5>
          <ul className="space-y-3">
            <li className="cursor-pointer text-gray-700 hover:text-blue-500">My Page</li>
          </ul>

          {/* Settings Section */}
          <hr />
          <h5 className="text-lg font-semibold">
            <FontAwesomeIcon icon={faCog} className="mr-2" />
            Settings
          </h5>
          <ul className="space-y-3">
            <li className="cursor-pointer text-gray-700 hover:text-blue-500" onClick={showAccountInfo}>Account Information</li>
            <li className="cursor-pointer text-gray-700 hover:text-blue-500">Communication Preferences</li>
          </ul>
        </div>
      </div>
    </div>
  );


  return (
    // <div id="bootstrap-overrides">
    <>
      <div className="portal-header mt-3 lg:h-[4rem] flex">
        <div className="mobile-tabs flex">
          <p className="mo-drawer" onClick={toggleDrawer(true)}> <ArrowBackIcon className='mo-icon' /> Portal</p>
          <p className="inv-text" onClick={showInvoices}>Invoices</p>
          <p className="ord-text" onClick={showOrders}>Orders</p>
          <p className="quo-text" onClick={showQuotes}>Quotes</p>
        </div>
        <FullWidthTabs
          toggleDrawer={toggleDrawer(true)}
          showInvoices={showInvoices}
          showDashboard={showDashboard}
          showOrders={showOrders}
          showQuotes={showQuotes}
          showAccountInfo={showAccountInfo}

        />
        <Drawer open={drawerOpen} onClose={toggleDrawer(false)}>
          {DrawerList}
        </Drawer>
      </div>
      <div className="m-tabs-cover ">
        {dataSelection()}
      </div>
    </>


  );
}

export default Portal;





function OrderRow(props) {
  const { order, childColumn, reOrderItems, getReport } = props;
  const [open, setOpen,] = React.useState(false);

  return (
    <React.Fragment >
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowDownIcon /> : <AddIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {order.sopnumbe}
        </TableCell>
        <TableCell align="center">{order.origin === 1 ? "In Store" : order.origin === 3 ? "Online" : order.origin === 0 ? "Unknown" : "MOB"}</TableCell>
        <TableCell align="center">{format(Date.parse(order.ordrdate), "MM/dd/yyyy")}</TableCell>
        <TableCell align="center">{order.locncode}</TableCell>
        <TableCell align="center">{format(Date.parse(order.duedate), "MM/dd/yyyy")}</TableCell>
        <TableCell align="center">{formatter.format(order.docamnt)}</TableCell>
        <TableCell align="center">{order.custname}</TableCell>
        <TableCell align="center">{order.status}</TableCell>
        <TableCell align="center" onClick={() => reOrderItems(order.sopnumbe)} className="cursor-pointer">REORDER</TableCell>
        <TableCell align="center" className="cursor-pointer"><img src={SaveLogo} width='30' height='30'
          onClick={() => getReport(order.sopnumbe, "Order", "Order")} /></TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Details
              </Typography>
              <Table size="small" aria-label="purchases" sx={{ border: 'none', boxShadow: 'none', marginLeft: 10 }}>
                <TableHead>
                  <TableRow >
                    {childColumn.map((column) => (
                      <TableCell

                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth, backgroundColor: '#e6e6e6' }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {order.details.map((detail) => (
                    <TableRow key={detail.sopnumbe}>
                      <TableCell component="th" scope="row">
                        {detail.sopnumbe}
                      </TableCell>
                      <TableCell align="right">{format(Date.parse(detail.reqShipDate), "MM/dd/yyyy")}</TableCell>
                      <TableCell align="right">{detail.itemnmbr}</TableCell>
                      <TableCell align="right">
                        {detail.itemdesc}
                      </TableCell>
                      <TableCell align="right">{detail.locncode}</TableCell>
                      <TableCell align="right">{formatter.format(detail.unitprce)}</TableCell>
                      <TableCell align="right">{detail.quantity}</TableCell>
                      <TableCell align="right">{formatter.format(detail.xtndprce)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const dateFormater1 = (date) => new Date(date).toISOString().split("T")[0];

const formatDate = (dateString) => {
  if (!dateString) return "None";
  const date = new Date(dateString);
  return isNaN(date.getTime())
    ? "Invalid Date"
    : date.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" });
};





function InvoiceRow(props) {
  const { invoice, childColumn, reOrderItems, getReport } = props;
  const [open, setOpen,] = React.useState(false);
  console.log(`Account Amount: ${invoice.acctamnt}`);
  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowDownIcon /> : <AddIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {invoice.sopnumbe}
        </TableCell>
        <TableCell  >{invoice.originString}</TableCell>
        <TableCell >{formatDate(invoice.invodate)}</TableCell>
        <TableCell >{invoice.pymttype === 1 ? "Cash Deposit " : invoice.pymttype === 2 ? "Check Deposit" : invoice.pymttype === 3 ? "Credit Card Deposit" :
          invoice.pymttype === 4 ? "Cash Payment" : invoice.pymttype === 5 ? "Check Payment" : invoice.pymttype === 6 ? "Credit Card Payment" : invoice.pymttype}</TableCell>
        <TableCell >{formatter.format(invoice.subtotal)}</TableCell>
        <TableCell >{formatDate(invoice.duedate)}</TableCell>
        <TableCell >{formatter.format(invoice.taxamnt)}</TableCell>
        <TableCell >{formatter.format(invoice.docamnt)}</TableCell>
        <TableCell >{Date.parse(invoice.duedate) < Date.now() && invoice.docamnt > 0 ?
          (<div className='bold-red'>{formatter.format(invoice.docamnt)}</div>) :
          (<div className='bold'>{formatter.format(invoice.docamnt)}</div>)}</TableCell>
        <TableCell onClick={() => reOrderItems(invoice.sopnumbe)} className="cursor-pointer">REORDER</TableCell>
        <TableCell className="">{invoice.acctamnt <= 0 ? (<div className="flex space-x-2">
          <img
            src={SaveLogo}
            width='30'
            height='30'
            onClick={() => getReport(invoice.sopnumbe, "Invoice_Posted", "PostedInvoice")}
          />
          <img
            src={paidLogo}
            width='50'
            height='50'
          />
        </div>) : invoice.docamnt > 0.01 ? (
          <div className='flex-row space-x-3'>
            <div className=' cursor-pointer'>
              <img
                src={SaveLogo}
                width='30'
                height='30'
                onClick={() => getReport(invoice.sopnumbe, "Invoice_Posted", "PostedInvoice")}
              />
            </div>
            <div className='cursor-pointer'>
              <a href="https://primepowerserv.securepayments.cardpointe.com/pay?"
                target="_blank"
                rel="noreferrer noopener">
                <img
                  src={PayLogo}
                  width='30'
                  height='30'
                /></a>
            </div>
          </div>
        ) : (
          <div className='flex-row'>
            <div className='flex-col'>
              <img
                src={SaveLogo}
                width='30'
                height='30'
                onClick={() => getReport(invoice.sopnumbe, "Invoice_Posted", "PostedInvoice")}
              />
            </div>
          </div>
        )}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1, }}>
              <Typography variant="h6" gutterBottom component="div">
                Details
              </Typography>
              <Table size="small" aria-label="purchases" sx={{ border: 'none', boxShadow: 'none', marginLeft: 10, }}>
                <TableHead>
                  <TableRow >
                    {childColumn.map((column) => (
                      <TableCell

                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth, backgroundColor: '#e6e6e6' }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoice.details.map((detail) => (
                    <TableRow key={detail.sopnumbe}>
                      <TableCell component="th" scope="row">
                        {detail.sopnumbe}
                      </TableCell>
                      <TableCell align="right">{format(Date.parse(detail.reqShipDate), "MM/dd/yyyy")}</TableCell>
                      <TableCell align="right">{detail.itemnmbr}</TableCell>
                      <TableCell align="right">
                        {detail.itemdesc}
                      </TableCell>
                      <TableCell align="right">{detail.locncode}</TableCell>
                      <TableCell align="right">{formatter.format(detail.unitprce)}</TableCell>
                      <TableCell align="right">{detail.quantity}</TableCell>
                      <TableCell align="right">{formatter.format(detail.xtndprce)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
            <Box sx={{ margin: 1, }}>
              <Typography variant="h6" gutterBottom component="div">
                Payments
              </Typography>
              <Table size="small" aria-label="purchases" sx={{ border: 'none', boxShadow: 'none', marginLeft: 10, }}>
                <TableHead>
                  <TableRow >
                    {PaymentDataColumns.map((column) => (
                      <TableCell

                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth, backgroundColor: '#e6e6e6' }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoice.paymentData && invoice.paymentData.map((pym) => (
                    <TableRow key={pym.doc}>
                      <TableCell component="th" scope="row">
                        {pym.doc}
                      </TableCell>
                      <TableCell align="right">{pym.paymentMethod}</TableCell>
                      <TableCell align="right">
                        {pym.remainingAmt}
                      </TableCell>
                      <TableCell align="right">{pym.customerName}</TableCell>
                      <TableCell align="right">{format(Date.parse(pym.docDate), "MM/dd/yyyy")}</TableCell>
                      <TableCell align="right">{format(Date.parse(pym.dueDate), "MM/dd/yyyy")}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

function QuoteRow(props) {
  const { quote, childColumn, reOrderItems, getReport } = props;
  const [open, setOpen,] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowDownIcon /> : <AddIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {quote.sopnumbe}
        </TableCell>
        <TableCell align="right">{format(Date.parse(quote.quotedat), "MM/dd/yyyy")}</TableCell>
        <TableCell align="right">{formatter.format(quote.docamnt)}</TableCell>
        <TableCell align="right">{quote.custname}</TableCell>
        <TableCell align="right" onClick={() => reOrderItems(quote.sopnumbe)} className="cursor-pointer">REORDER</TableCell>
        <TableCell align="right"><img src={SaveLogo} width='30' height='30' className="ml-10 cursor-pointer"
          onClick={() => getReport(quote.sopnumbe, "Quote", "Quote")} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Details
              </Typography>
              <Table size="small" aria-label="purchases" sx={{ border: 'none', boxShadow: 'none', marginLeft: 10 }}>
                <TableHead>
                  <TableRow >
                    {childColumn.map((column) => (
                      <TableCell

                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth, backgroundColor: '#e6e6e6' }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {quote.details.map((detail) => (
                    <TableRow key={detail.sopnumbe}>
                      <TableCell component="th" scope="row">
                        {detail.sopnumbe}
                      </TableCell>
                      <TableCell align="right">{format(Date.parse(detail.reqShipDate), "MM/dd/yyyy")}</TableCell>
                      <TableCell align="right">{detail.itemnmbr}</TableCell>
                      <TableCell align="right">
                        {detail.itemdesc}
                      </TableCell>
                      <TableCell align="right">{detail.locncode}</TableCell>
                      <TableCell align="right">{formatter.format(detail.unitprce)}</TableCell>
                      <TableCell align="right">{detail.quantity}</TableCell>
                      <TableCell align="right">{formatter.format(detail.xtndprce)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

